export default __webpack_public_path__ + "static/media/safety-box.5a1aa460.svg";